import { useCollapsibleView } from "@/features/collapsible-view";
import { ResponseItemType } from "@/entities/form-metadata";
import { FeatureContainerRenderer } from "./feature-container-renderer";
import { FieldGroupRenderer } from "./field-group-renderer";
import styles from "./FullFormStructure.module.scss";

export const FullFormStructure = () => {
    const fieldGroupsWithCollapsible = useCollapsibleView();

    return fieldGroupsWithCollapsible.map((fieldGroupOrFeature, idx) => {
        if (fieldGroupOrFeature.type === ResponseItemType.FeatureContainer) {
            return (
                <FeatureContainerRenderer
                    key={idx}
                    uuids={fieldGroupOrFeature.ids}
                    layout={fieldGroupOrFeature.layout}
                    containerClassName={styles.itemContainer}
                />
            );
        }

        return (
            <FieldGroupRenderer key={idx} fieldGroup={fieldGroupOrFeature} containerClassName={styles.itemContainer} />
        );
    });
};
